import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';

const languages = [
  { code: 'no', name: 'Norsk', shortCode: 'NO' },
  { code: 'en', name: 'English', shortCode: 'EN' },
];

export function LanguageSwitcher({ variant = 'icon', className = '' }) {
  const { i18n } = useTranslation();

  // Handle language codes like 'en-US', 'en-GB', etc.
  const langCode = i18n.language?.split('-')[0] || 'no';
  const currentLanguage = languages.find(lang => lang.code === langCode) || languages[0];

  const changeLanguage = (languageCode) => {
    i18n.changeLanguage(languageCode);
    localStorage.setItem('i18nextLng', languageCode);
  };

  if (variant === 'full') {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className={`flex items-center gap-2 ${className}`}>
            <span className="text-xs font-bold bg-white/10 px-1.5 py-0.5 rounded">{currentLanguage.shortCode}</span>
            <span>{currentLanguage.name}</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {languages.map((language) => (
            <DropdownMenuItem
              key={language.code}
              onClick={() => changeLanguage(language.code)}
              className={`flex items-center gap-2 cursor-pointer ${
                langCode === language.code ? 'bg-accent' : ''
              }`}
            >
              <span className="text-xs font-bold bg-accent/50 px-1.5 py-0.5 rounded">{language.shortCode}</span>
              <span>{language.name}</span>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className={className}>
          <Globe className="h-5 w-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {languages.map((language) => (
          <DropdownMenuItem
            key={language.code}
            onClick={() => changeLanguage(language.code)}
            className={`flex items-center gap-2 cursor-pointer ${
              langCode === language.code ? 'bg-accent' : ''
            }`}
          >
            <span className="text-xs font-bold bg-accent/50 px-1.5 py-0.5 rounded">{language.shortCode}</span>
            <span>{language.name}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default LanguageSwitcher;
